import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

const getRequestHouses = async (streetId) => {
  const res = await request.get(
    `/Request/houses/${streetId}`,
    {},
    'При загрузке списка домов произошла ошибка'
  );
  return res;
};

const useRequestHouses = (streetId, options) =>
  useQuery(
    queryKeys.requestHouses(streetId),
    () => getRequestHouses(streetId),
    options
  );

export default useRequestHouses;
